<template>
  <div class="ivc-fleet-settings flex column">
    <Modal v-if="showDeleteModal" @hide="showDeleteModal = false" class="modal">
      <span slot="header" style="color: #171C26">Are you sure?</span>
      <div slot="body" style="padding: 0 30px;">
        <p>
          By clicking Confirm, you agree to be contacted by an OnStar Vehicle Insights representative, which will contact you in order to remove the selected cameras from your account. You will be contacted in 3-5 business days.
        </p>
        <b>Choose how to be contacted:</b>
        <div class="contact-checkboxes">
          <CheckBox :checked="phoneChecked" @toggle="phoneChecked = !phoneChecked" />
          <span>
            <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M3 0C3.36667 0 3.66667 0.3 3.66667 0.666667C3.66667 1.5 3.8 2.3 4.04667 3.04667C4.11185 3.25407 4.07695 3.48255 3.93729 3.66187L3.88 3.72667L2.1301 5.45606C3.0501 7.26411 4.5089 8.75379 6.28939 9.72559L6.52344 9.84939L8.27333 8.12C8.40667 7.99333 8.57333 7.92667 8.74667 7.92667C8.81333 7.92667 8.88667 7.93333 8.95333 7.96C9.7 8.20667 10.5067 8.34 11.3333 8.34C11.6738 8.34 11.9568 8.59867 11.9955 8.9292L12 9.00667V11.3333C12 11.7 11.7 12 11.3333 12C5.07333 12 0 6.92667 0 0.666667C0 0.326191 0.258674 0.0431973 0.589201 0.00450683L0.666667 0H3ZM8.78133 8.742L7.16267 10.342L7.18746 10.353C8.39922 10.8722 9.72809 11.1707 11.1235 11.198L11.2 11.198V9.13733L11.0332 9.13467C10.3337 9.10978 9.6399 8.99756 8.95111 8.79509L8.78133 8.742ZM2.86867 0.8H0.801333L0.802047 0.876475C0.827936 2.20214 1.09863 3.46773 1.5708 4.6299L1.64533 4.80933L3.26067 3.21333L3.19955 3.016C3.00708 2.35513 2.89657 1.66849 2.87195 0.967792L2.86867 0.8Z" fill="#171C26"/>
            </svg>
            <span>+1 (833) 266-6565</span>
          </span>
          <CheckBox :checked="emailChecked" @toggle="emailChecked = !emailChecked" />
          <span>
            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="10" viewBox="0 0 14 10" fill="none">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M13.4001 0.601562V7.66773C13.4001 8.62503 12.6241 9.40107 11.6668 9.40107H2.33343C1.37614 9.40107 0.600098 8.62503 0.600098 7.66773V0.601562H13.4001ZM12.1101 3.78267L11.9896 3.84132L7.0001 6.09915L2.01064 3.84132C1.78432 3.7389 1.57932 3.60407 1.40012 3.44377L1.4001 7.66773C1.4001 8.15288 1.77025 8.55157 2.24354 8.59679L2.33343 8.60107H11.6668C12.1822 8.60107 12.6001 8.1832 12.6001 7.66773L12.6018 3.44223C12.4545 3.57422 12.2898 3.68898 12.1101 3.78267ZM12.6001 1.4009H1.4001V1.67556L1.40676 1.80087C1.45529 2.33176 1.76608 2.80509 2.23555 3.06031L2.34046 3.11247L7.0001 5.2209L11.6597 3.11247C12.1965 2.86959 12.5533 2.35324 12.5958 1.77186L12.6001 1.65477V1.4009Z" fill="#171C26"/>
            </svg>
            <span>fleetemail@handh.com</span>
          </span>
        </div>
        <p style="color: #71798A">You can update your contact info in the Account Details tab in the Account Settings Page</p>
        <div class="modal-buttons">
          <button
            type="cancel"
            class="button1"
            @click="showDeleteModal = false"
          >
            Cancel
          </button>
          <button
            type="submit"
            class="button2"
            @click="showDeleteModal = false"
          >
            Confirm
          </button>
        </div>
      </div>
    </Modal>
    <Modal v-if="showCamSettingsModal" @hide="showCamSettingsModal = false" @closeModalManual="closeCamSettings" x class="modal">
      <span slot="header" style="color: #171C26">Lytx 123456789101112 Device Settings</span>
      <div slot="body" style="padding: 0 30px;">
        <div class="cam-settings-row">
          <h3>Driver Audio Alerts</h3>
          <div class="cam-settings-control">
            <div class="dot" :class="{ grey: !audioAlertToggle }" />
            <span>{{ audioAlertToggle ? 'On' : 'Off' }}</span>
            <ToggleButton
              v-model="audioAlertToggle"
              :width="36"
              :color="{ checked: '#0072C8', unchecked: '#969FB3' }"
            />
          </div>
        </div>
        <div class="learn-more-wrap">
          <InfoHoverIcon
            msg="Camera settings may require some time to be implemented. Revisit this settings to verify the desired status, and retry if needed."
          />
          Learn More
        </div>
      </div>
    </Modal>
    <b style="margin: -12px 0 12px 0;">My Cameras</b>
    <div class="flex" style="margin-top: -12px">
      <div class="big-number-wrap flex column">
        <div class="big-number">{{ numAssigned }}</div>
        <div class="flex center">
          <div class="dot" />
          <span class="ivc-status">{{ $t("message.assigned") }}</span>
        </div>
      </div>
      <div class="big-number-wrap flex column">
        <div class="big-number">{{ numUnassgined }}</div>
        <div class="flex center">
          <div class="dot orange" />
          <span class="ivc-status">Unassigned</span>
        </div>
      </div>
      <div class="big-number-wrap flex column">
        <div class="big-number">{{ numOrdered }}</div>
        <div class="flex center">
          <div class="dot grey" />
          <span class="ivc-status">Ordered</span>
        </div>
      </div>
    </div>
    <BarChart
      class="ivc-bar"
      :value="percentAssigned"
      :width="363"
      :height="6"
      :color="'#1CD8AA'"
      :secondaryValue="percentUnassigned"
      :secondaryColor="'#FFAB40'"
      rounded
    />
    <div class="line" />
    <div class="check-item">
      <div class="noti-text">
        <b>Camera Updates</b>
        <p>Get notified on camera updates, when a camera was added to your fleet, or if a potential issue has been detected</p>
      </div>
      <div class="noti-toggles">
        <img src="@/assets/notifications-24-px.svg?external" />
        <ToggleButton
          :value="true"
          :width="36"
          :color="{ checked: '#0072C8', unchecked: '#969FB3' }"
        />
        <img src="@/assets/envelope-24-px.svg?external" />
        <ToggleButton
          :value="true"
          :width="36"
          :color="{ checked: '#0072C8', unchecked: '#969FB3' }"
        />
      </div>
    </div>
    <div class="check-item">
      <div class="noti-text">
        <b>Driver Proactive Alerts <InfoHoverIcon
              msg="This feature is currently only available with Lytx cameras." clearIcon
            /></b>
        <p>Audio and visual alerts that notifies a driver of a risky behavior to help coach and correct in real-time.</p>
      </div>
      <div style="margin: 0 8px 0 auto">
        <ToggleButton
          :value="true"
          :width="36"
          :color="{ checked: '#0072C8', unchecked: '#969FB3' }"
        />
      </div>
    </div>
    <div class="camera-list-top-bar">
      <div class="search">
        <span>Search Devices</span>
        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="13" viewBox="0 0 12 13" fill="none">
          <path fill-rule="evenodd" clip-rule="evenodd" d="M4.69695 0.296875C7.29532 0.296875 9.40171 2.40327 9.40171 5.00164C9.40171 6.12963 9.00475 7.16491 8.34289 7.97539L11.7286 11.3598C12.0719 11.7032 12.0983 12.2434 11.8078 12.617L11.7286 12.7067L7.67071 8.64758C6.86022 9.30943 5.82494 9.7064 4.69695 9.7064C2.09858 9.7064 -0.0078125 7.6 -0.0078125 5.00164C-0.0078125 2.40327 2.09858 0.296875 4.69695 0.296875ZM4.69695 1.24926C2.62457 1.24926 0.944569 2.92925 0.944569 5.00164C0.944569 7.07402 2.62457 8.75402 4.69695 8.75402C6.76933 8.75402 8.44933 7.07402 8.44933 5.00164C8.44933 2.92925 6.76933 1.24926 4.69695 1.24926Z" fill="#171C26"/>
        </svg>
      </div>
      <div class="flex" style="gap: 5px;">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
          <path fill-rule="evenodd" clip-rule="evenodd" d="M9.81002 12.729L3.33002 3H20.682L14.202 12.729V18.804L9.81002 21V12.729ZM17.91 4.458H6.05702L11.277 12.288V18.633L12.735 17.904V12.288L17.91 4.458Z" fill="#0072C8"/>
        </svg>
        <svg @click="showDeleteModal = true" style="cursor: pointer" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
          <path fill-rule="evenodd" clip-rule="evenodd" d="M15.6 2.90039V4.90039H19.914V6.10039L19.741 6.09839C19.0857 6.17948 18.5583 6.67536 18.437 7.32439L18.417 7.46639L18.408 7.56439V7.55839L17.265 19.6514C17.1871 20.4729 16.4972 21.1005 15.672 21.1004H8.328C7.50244 21.1004 6.8124 20.4723 6.735 19.6504L5.567 7.29639C5.43653 6.66505 4.92106 6.18528 4.282 6.10039H4V4.90039H8.4V2.90039H15.6ZM17.34 6.10039H6.66L7.93 19.5384C7.94958 19.7436 8.12188 19.9003 8.328 19.9004H15.672C15.8781 19.9003 16.0504 19.7436 16.07 19.5384L17.34 6.10039ZM12.6 7.50039V18.2964H11.4V7.50039H12.6ZM15.6 7.50039L15.08 17.0674C15.0438 17.739 14.4885 18.2648 13.816 18.2644L14.401 7.50039H15.6ZM9.572 7.50039L10.157 18.2644C9.48485 18.2643 8.93013 17.7386 8.894 17.0674L8.375 7.50039H9.572ZM14.4 4.10039H9.6V4.90039H14.4V4.10039Z" fill="#0072C8"/>
        </svg>
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
          <path fill-rule="evenodd" clip-rule="evenodd" d="M20.6 18.9534V20.5004L20.5 20.6004H3.50002L3.40002 20.5004V18.9534L3.50002 18.8534H20.5L20.6 18.9534ZM12.874 3.50039V13.7204L15.975 10.4164L16.037 10.3554C16.3387 10.0686 16.7423 9.91409 17.1583 9.92611C17.5744 9.93812 17.9684 10.1157 18.253 10.4194V10.5554L12.073 17.1684H11.927L5.74702 10.5554L5.75002 10.4164L5.81202 10.3554C6.44513 9.76333 7.43703 9.79188 8.03502 10.4194L11.126 13.7194V3.50039L11.226 3.40039H12.773L12.874 3.50039Z" fill="#0072C8"/>
        </svg>
      </div>
    </div>
    <div class="camera-list-item" v-for="(camera, i) of cameras" :key="i">
      <CheckBox class="checkbox" :checked="camera.checked" @toggle="camera.checked = !camera.checked" uncheckedFill="#71798A" />
      <div class="camera-img-wrap">
        <img src="@/assets/camera-guide/photo2.png" />
        <div class="camera-status">
          <div class="dot" :class="cameraStatusDotClassName(camera.status)" />
          <span>{{ cameraStatusName(camera.status) }}</span>
        </div>
      </div>
      <div class="camera-details">
        <b>{{ camera.name }}</b>
        <div class="flex" style="gap: 12px;">
          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M14.856 6.65625C14.5346 6.65434 14.2472 6.45586 14.1315 6.156L12.8813 2.90625H5.12476L3.87526 6.16275C3.75751 6.45975 3.47026 6.6555 3.15001 6.65625H2.12476V7.59375H3.13126L2.28151 8.79375V15.0938H5.71876V12.594H12.2813V15.0938H15.7185V8.79375L14.8688 7.59375H15.8753V6.65625H14.856ZM5.76226 3.84375H12.2378L13.2563 6.50025C13.2765 6.558 13.3013 6.615 13.3313 6.669H4.66876C4.69801 6.61425 4.72276 6.558 4.74376 6.50025L5.76226 3.84375ZM4.78126 14.1562H3.21901V12.3997C3.46051 12.525 3.72826 12.591 3.99976 12.594H4.78126V14.1562ZM13.2188 14.1562V12.594H14.0003C14.2718 12.591 14.5403 12.525 14.781 12.3997V14.1562H13.2188ZM14.0003 11.6565H3.99976C3.56844 11.6561 3.21901 11.3063 3.21901 10.875V9.09375L4.04401 7.92525C4.18876 7.72275 4.41976 7.59975 4.66876 7.59375H13.3185C13.5675 7.59975 13.7985 7.72275 13.944 7.92525L14.769 9.09375V10.875C14.769 11.3018 14.4263 11.6497 14.0003 11.6565ZM3.99976 9.156H6.50026V10.0935H3.99976V9.156ZM11.4998 9.156H14.0003V10.0935H11.4998V9.156Z" fill="#0072C8"/>
          </svg>
          <span class="vehicle-name">{{ camera.vehicle }}</span>
          <div style="position: relative">
            <svg @click="camera.showDropdown = !camera.showDropdown" style="cursor: pointer" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M14.623 10.0075C14.6198 9.33593 15.0219 8.72866 15.6415 8.46942C16.261 8.21018 16.9758 8.35013 17.4518 8.82389C17.9279 9.29765 18.0712 10.0117 17.815 10.6325C17.5587 11.2533 16.9534 11.6583 16.2818 11.6583C15.3688 11.6583 14.6274 10.9205 14.623 10.0075ZM8.34524 10.0075C8.34524 9.09583 9.08433 8.35674 9.99604 8.35674C10.9077 8.35674 11.6468 9.09583 11.6468 10.0075C11.6468 10.9192 10.9077 11.6583 9.99604 11.6583C9.08433 11.6583 8.34524 10.9192 8.34524 10.0075ZM2.05953 10.0075C2.05632 9.33521 2.45927 8.72744 3.07982 8.46867C3.70036 8.2099 4.41573 8.35131 4.89114 8.82672C5.36655 9.30213 5.50796 10.0175 5.24919 10.638C4.99041 11.2586 4.38265 11.6615 3.71032 11.6583C2.79861 11.6583 2.05953 10.9192 2.05953 10.0075Z" fill="#171C26"/>
            </svg>
            <div class="dropdown" v-show="camera.showDropdown">
              <div @click="camera.showDropdown = false">Change Vehicle</div>
              <div @click="camera.showDropdown = false; showAssignModal = true;">Assign Vehicle</div>
            </div>
          </div>
        </div>
        <div class="flex" style="gap: 2px; color: #71798A;">
          <svg v-if="cameraAlertColor(camera.alertLevel) === '#1CD8AA'" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 17" fill="none">
            <path d="M9.49265 12.6629C9.49498 12.6605 9.49729 12.658 9.49957 12.6555C9.50861 12.6476 9.51744 12.6393 9.52605 12.6307L13.4917 8.16525C13.7039 7.95303 13.6998 7.60485 13.4826 7.38758C13.2653 7.1703 12.9171 7.1662 12.7049 7.37842L9.07185 11.4787L7.61002 10.2764C7.3978 10.0642 7.04962 10.0683 6.83234 10.2856C6.61506 10.5029 6.61096 10.851 6.82318 11.0633L8.79994 12.7051C9.01216 12.9173 9.26599 12.8898 9.48327 12.6725C9.48643 12.6694 9.48956 12.6662 9.49265 12.6629Z" fill="#1CD8AA"/>
            <path fill-rule="evenodd" clip-rule="evenodd" d="M9.99999 16.6663C6.3181 16.6663 3.33333 13.6816 3.33333 9.99967C3.33333 6.31778 6.3181 3.33301 9.99999 3.33301C13.6819 3.33301 16.6667 6.31778 16.6667 9.99967C16.6667 13.6816 13.6819 16.6663 9.99999 16.6663ZM9.99999 15.833C13.2217 15.833 15.8333 13.2213 15.8333 9.99967C15.8333 6.77801 13.2217 4.16634 9.99999 4.16634C6.77833 4.16634 4.16666 6.77801 4.16666 9.99967C4.16666 13.2213 6.77833 15.833 9.99999 15.833Z" fill="#1CD8AA"/>
          </svg>
          <svg v-else xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" :fill="cameraAlertColor(camera.alertLevel)">
            <path d="M10.5625 12.292H9.43751V7.79199H10.5625V12.292Z" />
            <path d="M9.25001 14.2503C9.25001 13.8361 9.58579 13.5003 10 13.5003C10.4142 13.5003 10.75 13.8361 10.75 14.2503C10.75 14.6645 10.4142 15.0003 10 15.0003C9.58579 15.0003 9.25001 14.6645 9.25001 14.2503Z" />
            <path fill-rule="evenodd" clip-rule="evenodd" d="M10.3921 2.72693C10.5416 2.80561 10.6636 2.92789 10.7421 3.07754L17.6612 16.2802C17.8748 16.6878 17.7175 17.1915 17.3099 17.4051C17.1905 17.4677 17.0578 17.5003 16.923 17.5003H3.05532C2.59508 17.5003 2.22198 17.1272 2.22198 16.667C2.22198 16.5318 2.2549 16.3986 2.31788 16.2789L9.26651 3.07624C9.48086 2.66897 9.98479 2.51258 10.3921 2.72693ZM10.0025 4.36033L3.74417 16.2503H16.2333L10.0025 4.36033Z" />
          </svg>
          <span>Last seen: {{ camera.lastSeen }}</span>
        </div>
      </div>
      <svg @click="selectedCamera = i; showCamSettingsModal = true;" style="cursor: pointer;" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M19.392 12.833C19.4573 12.2796 19.4573 11.7204 19.392 11.167C19.349 10.843 19.464 10.517 19.7 10.292L20.758 9.26699L18.758 5.79199L17.333 6.16699C17.0208 6.25451 16.6856 6.19287 16.425 5.99999C15.9694 5.66719 15.4772 5.3877 14.958 5.16699C14.6697 5.04363 14.4503 4.79969 14.358 4.49999L14 3.04199H10L9.642 4.49999C9.558 4.81199 9.337 5.06999 9.042 5.19999C8.522 5.41999 8.03 5.69999 7.575 6.03299C7.30892 6.21458 6.9742 6.26398 6.667 6.16699L5.242 5.78299L3.242 9.25799L4.3 10.283C4.539 10.511 4.654 10.84 4.608 11.167C4.5427 11.7204 4.5427 12.2796 4.608 12.833C4.651 13.157 4.536 13.483 4.3 13.708L3.242 14.742L5.242 18.217L6.667 17.833C6.97922 17.7455 7.31436 17.8071 7.575 18C8.031 18.333 8.523 18.612 9.042 18.833C9.338 18.959 9.559 19.214 9.642 19.525L10 20.958H14L14.358 19.5C14.442 19.188 14.663 18.93 14.958 18.8C15.4788 18.5825 15.9714 18.3028 16.425 17.967C16.6911 17.7854 17.0258 17.736 17.333 17.833L18.758 18.242L20.758 14.767L19.7 13.742C19.4531 13.5087 19.3377 13.1683 19.392 12.833ZM18.15 11.292C18.176 11.524 18.19 11.758 18.192 11.992C18.1907 12.2229 18.1767 12.4536 18.15 12.683C18.0638 13.3947 18.3133 14.106 18.825 14.608L19.192 14.958L18.158 16.733L17.675 16.6C16.9878 16.3997 16.2463 16.5358 15.675 16.967C15.2988 17.2504 14.8903 17.4881 14.458 17.675C13.805 17.9563 13.3211 18.5268 13.15 19.217L13.025 19.7H10.975L10.85 19.217C10.6789 18.5268 10.195 17.9563 9.542 17.675C9.1113 17.4984 8.70283 17.2719 8.325 17C7.75367 16.5688 7.01222 16.4327 6.325 16.633L5.842 16.767L4.808 14.967L5.175 14.617C5.68544 14.1175 5.93484 13.4091 5.85 12.7C5.83757 12.4668 5.83757 12.2332 5.85 12C5.83731 11.7695 5.83731 11.5385 5.85 11.308C5.93617 10.5963 5.68675 9.88501 5.175 9.38299L4.808 9.03299L5.842 7.25799L6.325 7.39199C7.01614 7.58525 7.75796 7.43986 8.325 6.99999C8.702 6.71799 9.11 6.47999 9.542 6.29199C10.195 6.01064 10.6789 5.44016 10.85 4.74999L10.975 4.26699H13.025L13.15 4.74999C13.3228 5.45852 13.8249 6.04124 14.5 6.31699C14.916 6.49999 15.31 6.72899 15.675 6.99999C16.2463 7.43122 16.9878 7.56727 17.675 7.36699L18.158 7.23299L19.192 9.00799L18.825 9.35799C18.3071 9.86314 18.0571 10.5825 18.15 11.3V11.292ZM12 8.04199C10.6513 8.03896 9.40348 8.75566 8.72651 9.92213C8.04954 11.0886 8.0463 12.5276 8.71801 13.6971C9.38972 14.8666 10.6343 15.589 11.983 15.592C13.3317 15.595 14.5795 14.8783 15.2565 13.7119C15.9335 12.5454 15.9367 11.1064 15.265 9.93685C14.5933 8.76735 13.3487 8.04503 12 8.04199ZM12 14.333C10.6193 14.333 9.5 13.2137 9.5 11.833C9.5 10.4523 10.6193 9.33299 12 9.33299C13.3807 9.33299 14.5 10.4523 14.5 11.833C14.5 13.2137 13.3807 14.333 12 14.333Z" fill="#0072C8"/>
      </svg>
    </div>
    <ModalView v-show="showAssignModal" @hide="showAssignModal = false">
      <AssignVehicleDriver header="Assign vehicle to camera" :vehicles="dataset.vehicles" @hide="showAssignModal = false" />
    </ModalView>
    <BaseAlert class="alert-fixed" v-if="isAudioAlertSuccess" type="success" :isDismissible="true" @closed="isAudioAlertSuccess = false"><strong>Driver audio alert was successfully requested.</strong></BaseAlert>
    <BaseAlert class="alert-fixed" v-if="isAudioAlertError" type="danger" :isDismissible="true" @closed="isAudioAlertError = false"><strong>Driver Audio Alert request to turn on failed, please retry at a later time.</strong></BaseAlert>
  </div>
</template>

<script>
import BarChart from "@/components/demo/BarChart.vue";
import Modal from "@/components/demo/Modal.vue";
import CheckBox from "@/components/demo/CheckBox.vue";
import { ToggleButton } from "vue-js-toggle-button";
import AssignVehicleDriver from "./AssignVehicleDriver.vue";
import ModalView from "./ModalView.vue";
import InfoHoverIcon from "./InfoHoverIcon.vue";
import BaseAlert from "@/components/BaseAlert.vue";

const ALERT_LEVEL = {
  GREEN: 0,
  YELLOW: 1,
  RED: 2,
};
const CAMERA_STATE = {
  UNASSIGNED: 9,
  ASSIGNED: 1,
  ORDERED: 3,
};

export default {
  props: {
    dataset: Object,
  },
  components: {
    BarChart,
    Modal,
    ToggleButton,
    CheckBox,
    AssignVehicleDriver,
    ModalView,
    InfoHoverIcon,
    BaseAlert,
},
  data() {
    return {
      numEnrolled: 3,
      numNotEnrolled: 0,
      currentSlide: 0,
      numSlides: 4,
      showCameraDropdown: false,
      showDeleteModal: false,
      showAssignModal: false,
      phoneChecked: false,
      emailChecked: false,
      showCamSettingsModal: false,
      selectedCamera: -1,
      cameras: [
        {
          name: 'Lytx 123456789101112',
          status: CAMERA_STATE.ASSIGNED,
          vehicle: '2024 Silverado LD 121',
          lastSeen: 'Today, at 2:30 PM',
          alertLevel: ALERT_LEVEL.GREEN,
          checked: false,
          showDropdown: false,
          audioAlertToggle: false,
        },
        {
          name: 'Lytx 123456789101112',
          status: CAMERA_STATE.ASSIGNED,
          vehicle: '2024 Malibu 201',
          lastSeen: '5/25/23 at 10:15 AM',
          alertLevel: ALERT_LEVEL.RED,
          checked: false,
          showDropdown: false,
          audioAlertToggle: false,
        },
        {
          name: 'Lytx 123456789101112',
          status: CAMERA_STATE.ASSIGNED,
          vehicle: '2024 Terrian 101',
          lastSeen: '5/27/23 at 10:15 AM',
          alertLevel: ALERT_LEVEL.YELLOW,
          checked: false,
          showDropdown: false,
          audioAlertToggle: false,
        },
        {
          name: 'Lytx 123456789101112',
          status: CAMERA_STATE.ASSIGNED,
          vehicle: '2024 Bolt EV 82',
          lastSeen: 'Today, at 10:15 AM',
          alertLevel: ALERT_LEVEL.GREEN,
          checked: false,
          showDropdown: false,
          audioAlertToggle: false,
        },
        {
          name: 'Lytx 123456789101112',
          status: CAMERA_STATE.ASSIGNED,
          vehicle: '2023 Enclave 98',
          lastSeen: '5/27/23 at 3:30 AM',
          alertLevel: ALERT_LEVEL.YELLOW,
          checked: false,
          showDropdown: false,
          audioAlertToggle: false,
        },
      ],
      isAudioAlertSuccess: false,
      isAudioAlertError: false,
    };
  },
  computed: {
    numAssigned() {
      return this.cameras.filter(o => o.status === CAMERA_STATE.ASSIGNED).length;
    },
    numUnassgined() {
      return CAMERA_STATE.UNASSIGNED;
    },
    numOrdered() {
      return CAMERA_STATE.ORDERED;
      // return this.cameras.filter(o => o.status === CAMERA_STATE.ORDERED).length;
    },
    percentAssigned() {
      const total = this.numAssigned + this.numUnassgined + this.numOrdered;
      return (this.numAssigned / total) * 100;
    },
    percentUnassigned() {
      const total = this.numAssigned + this.numUnassgined + this.numOrdered;
      return (this.numUnassgined / total) * 100;
    },
    allVehicles: {
      get() {
        return this.$store.state.ivcShowAll;
      },
      set(val) {
        this.$store.commit("setIVCShowAll", val);
      },
    },
    selectedVehicles() {
      return this.$store.state.ivcVehicles;
    },
    audioAlertToggle: {
      get() {
        if (this.selectedCamera < 0) return false;
        return this.cameras[this.selectedCamera].audioAlertToggle;
      },
      set(val) {
        console.log(val);
        if (val) {
          this.isAudioAlertSuccess = true;
          if (this.isAudioAlertError) this.isAudioAlertError = false;
        } else {
          this.isAudioAlertError = true;
          if (this.isAudioAlertSuccess) this.isAudioAlertSuccess = false;
        }
        if (this.selectedCamera < 0) return;
        this.cameras[this.selectedCamera].audioAlertToggle = val;
      },
    }
  },
  methods: {
    cameraStatusDotClassName(cameraStatus) {
      if (cameraStatus === CAMERA_STATE.ASSIGNED) return 'green';
      if (cameraStatus === CAMERA_STATE.UNASSIGNED) return 'orange';
      return 'grey';
    },
    cameraStatusName(cameraStatus) {
      if (cameraStatus === CAMERA_STATE.ASSIGNED) return 'Assigned';
      if (cameraStatus === CAMERA_STATE.UNASSIGNED) return 'Unassigned';
      return 'Ordered';
    },
    cameraAlertColor(cameraAlertLevel) {
      if (cameraAlertLevel === ALERT_LEVEL.RED) return '#FF4F72';
      if (cameraAlertLevel === ALERT_LEVEL.YELLOW) return '#FFAB40';
      return '#1CD8AA';
    },
    closeCamSettings() {
      this.showCamSettingsModal = false;
      setTimeout(() => {
        if (this.$store.state.showModal) this.$store.commit('toggleModal');
      }, 500);
    },
  },
};
</script>

<style lang="scss" scoped>
/* .ivc-fleet-settings {
  margin-left: 20px;
} */
.dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: var(--green);
  margin-right: 8px;
  margin-bottom: 16px;
}
.dot.blue {
  background-color: var(--blue);
}
.dot.grey {
  background-color: var(--grey);
}
.dot.orange {
  background-color: #FFAB40;
}
.ivc-status {
  font-size: 12px;
  color: var(--dark);
  margin-bottom: 16px;
}
.unit {
  color: var(--dark-grey);
}
.big-number-wrap {
  margin-right: 22px;
}
.big-number {
  font-size: 40px;
  color: var(--blue);
  font-weight: 400;
  margin-left: 4px;
  margin-top: 8px;
}
.ivc-bar {
  margin-bottom: 32px;
}
.ivc-vox-grid {
  display: grid;
  grid-template-columns: 32px 1fr;
  grid-template-rows: repeat(5, 1fr 1px) 1px;
  gap: 12px;
  align-items: center;
}
.ivc-vox-grid svg {
  width: 32px;
  height: 32px;
  fill: var(--dark-grey);
}
.line {
  width: 100%;
  height: 1px;
  background-color: var(--light-grey-2);
  grid-column: 1 / 4;
}
.tiny-txt {
  font-size: 12px;
  color: var(--dark-grey);
  margin-bottom: 16px;
}
.edit-btn {
  font-weight: 600;
  color: var(--blue);
  margin-left: 8px;
  cursor: pointer;
}

.check-item {
  padding: 20px 0;
  display: grid;
  grid-template-columns: auto 80px;
  grid-template-rows: auto;
  line-height: 18px;
  grid-gap: 10px;
  /* margin-left: 16px; */
  border-bottom: 1px solid #d1d6e0;
  align-items: center;
  > .noti-text > b {
    display: inline-flex;
    .info-hover-icon {
      margin-left: 4px;
    }
  }
}
.check-item p {
  margin: 0;
  margin-top: 10px;
  font-size: 15px;
  line-height: 19px;
  color: var(--dark);
}

.noti-toggles {
  display: grid;
  grid-template-columns: 24px 36px;
  gap: 12px;
}

.camera-list-top-bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 24px 0 12px 0;
}
.search {
  width: 230px;
  border: 1px solid #D1D6E0;
  padding: 6px 8px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  line-height: 14px;
}
.search svg {
  margin-right: 0;
}

.camera-list-item {
  padding: 14px 0;
  display: grid;
  grid-template-columns: 20px 112px 1fr 24px;
  border-bottom: 1px solid #C1C8D6;
}
.checkbox {
  margin-top: 10px;
}
.camera-img-wrap {
  width: 100%;
}
.camera-img-wrap img {
  width: 100%;
}
.camera-status {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 15px;
  line-height: 16px;
}
.camera-status .dot {
  margin: 0 6px 0 0;
}
.camera-details {
  display: flex;
  flex-direction: column;
  gap: 6px;
}
.vehicle-name {
  color: #0072C8;
  font-size: 15px;
  font-style: normal;
  font-weight: 600;
  line-height: 19px;
}

.modal {
  ::v-deep .modal-container {
    width: 500px;
    overflow-y: unset !important;
  }
  .contact-checkboxes {
    display: grid;
    justify-content: center;
    grid-template-columns: 12px 144px 12px 170px;
    gap: 10px;
    margin: 19px 0 30px 0;
    svg {
      margin-right: 6px;
    }
  }
  .modal-buttons {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    border-top: 0.1px solid var(--grey);
    height: 50px;
    margin-top: 10px;
    padding: 10px 0;
  
    button {
      font-weight: bold;
      background: transparent;
      border-radius: 0.25rem;
      padding: 5px 5%;
      width: 25%;
      cursor: pointer;
      &.button1 {
        color: var(--blue);
        border: 0.3px solid var(--pale-grey);
        margin-right: 3%;
      }
      &.button2 {
        border: 0;
        border: 0.3px solid var(--blue);
        background-color: var(--blue);
        color: #fff;
      }
      &.button2:disabled {
        border: 0.3px solid var(--pale-grey);
        color: var(--grey);
        background-color: var(--pale-grey);
      }
    }
  }
}
.dropdown {
  position: absolute;
  top: 20px;
  width: max-content;
  background-color: white;
  box-shadow: 0 1px 5px 0 rgba(26 28 30 / 20%), 0 2px 2px 0 rgba(26 28 30 / 14%),
    0 3px 1px -2px rgba(26 28 30 / 12%);
  z-index: 10;
  div {
    padding: 6px 16px;
    cursor: pointer;
    font-weight: 400;
    &:hover {
      background-color: rgba(105, 205, 255, 0.12);
    }
  }
}

.cam-settings-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-bottom: 120px;
  border-bottom: 1px solid #D1D6E0;
  h3 {
    margin: 0;
    color: #171C26;
    font-size: 17px;
    font-weight: 700;
    line-height: 21px;
  }
  .cam-settings-control {
    display: flex;
    align-items: center;
    gap: 10px;
    .dot {
      margin: 0;
    }
  }
}
.learn-more-wrap {
  padding: 30px 0;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 11px;
}

.alert-fixed {
  position: fixed;
  z-index: 9999;
  top: 20px;
  left: 295px;
  right: 20px;
  max-width: none;
  font-size: 17px;
}
</style>
